import Vue from 'vue';
// import * as spring from 'spring-data-rest-js';
import AuthBase from './auth_base';

const KEY_ACCESS_TOKEN = 'access_token';
const KEY_STORAGE_VERSION = 'storage_version';
const IS_ADMIN = 'is_admin';
const USER = 'user';
const DISPLAY_NAME = 'display_name';
const ICON = 'icon';
const storageVersion = '1';

class Authentication extends AuthBase {
  static #authStore = new Vue({
    data: {
      storageVersion: localStorage.getItem(KEY_STORAGE_VERSION),
      popup: undefined,
      polling: undefined,
      authorizationUrl: undefined,
      accessToken: localStorage.getItem(KEY_ACCESS_TOKEN),
      isAdmin: String(localStorage.getItem(IS_ADMIN)).toLowerCase() === 'true',
      user: localStorage.getItem(USER),
      displayName: localStorage.getItem(DISPLAY_NAME),
      icon: localStorage.getItem(ICON),
    },
    watch: {
      accessToken(current) {
        localStorage.setItem(KEY_ACCESS_TOKEN, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(KEY_ACCESS_TOKEN);
        }
        Authentication.setToken(current);
      },
      storageVersion(current) {
        localStorage.setItem(KEY_STORAGE_VERSION, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(KEY_STORAGE_VERSION);
        }
      },
      isAdmin(current) {
        localStorage.setItem(IS_ADMIN, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(IS_ADMIN);
        }
      },
      user(current) {
        localStorage.setItem(USER, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(USER);
        }
      },
      displayName(current) {
        localStorage.setItem(DISPLAY_NAME, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(DISPLAY_NAME);
        }
      },
      icon(current) {
        localStorage.setItem(ICON, current);
        if (typeof current === 'undefined') {
          localStorage.removeItem(ICON);
        }
      },
    },
    created() {
      Authentication.setToken(this.accessToken);
    },
  });

  constructor() {
    super(Authentication.#authStore);
    if (this.storageVersion !== storageVersion) {
      // console.log('Version doesn\'t match ', this.storageVersion, storageVersion);
      this.logout();
    }
  }

  get inProgress() {
    return !!this.store.$data.popup;
  }

  get accessToken() {
    return this.store.$data.accessToken;
  }

  get storageVersion() {
    return this.store.$data.storageVersion;
  }

  get isAdmin() {
    return this.store.$data.isAdmin;
  }

  get username() {
    return this.store.$data.user;
  }

  get name() {
    return this.store.$data.displayName;
  }

  get profilePicture() {
    return this.store.$data.icon;
  }

  get isAuthenticated() {
    return !!this.accessToken;
  }

  guard() {
    return async (to, from, next) => {
      // ONLY for localhost

      // if (window.location.href.startsWith('http://localhost')) {
      //   console.log('Auth Guard for LOCALHOST');
      //   const accessToken = "yjFWUGYduOkD7Rj0OIhr-g:XDTHyytTtopJTydsZZ9Tp7-tvMGB0MIrP784Hym98Ok";
      //   this.store.$data.accessToken = accessToken;
      //   this.store.$data.isAdmin = true;
      //   this.store.$data.user = 'vasil@softavail.com';
      //   this.store.$data.displayName = 'Vasil';
      //   this.store.$data.icon = '';
      //   Authentication.setToken(accessToken);
      // }
      const page = this.loginRedirect(to.path, to.fullPath);
      if (to.matched.some(record => record.meta.requiresAuth) && !this.isAuthenticated) {
        const page = this.loginRedirect(to.path, to.fullPath);
        next(page);
      } else {
        next();
      }

    };
  }

  loginRedirect(fromUri, fromFullPath) {
    this.show()
      .catch((ignored) => { /* Nothing to do */ });
    return {
      path: '/login',
      query: { redirect: fromFullPath },
    };
  }

  async handleCode(code) {
    const response = await this.authenticate({ code });

    this.store.$data.accessToken = response.token;
    this.store.$data.storageVersion = storageVersion;
    this.store.$data.isAdmin = String(response.admin).toLowerCase() === 'true';
    this.store.$data.user = response.user;
    this.store.$data.displayName = response.name;
    this.store.$data.icon = response.icon;
  }

  fetchAuthUrl() {
    if (this.store.$data.authorizationUrl) return Promise.resolve();

    // return spring.get('../login')
    //   .send()
    //   .then((response) => {
    //     this.store.$data.authorizationUrl = response.url;
    //   })
    //   .catch(reason => console.error('Error fetching authorization url!', reason));
  }

  // eslint-disable-next-line class-methods-use-this
  async authenticate(authentication) {
    // const request = spring.post('../login')
    //   .formBody(authentication);
    // try {
    //   return await request.send();
    // } catch (e) {
    //   throw e;
    // }
  }

  static setToken(token) {
    if (!token || !token.trim()) {
      // delete spring.requestConfig.globalFetchOptions.headers.Authorization;
    } else {
      // spring.requestConfig.globalFetchOptions.headers.Authorization = `Bearer ${token}`;
    }
  }

  logout() {
    this.store.$data.accessToken = undefined;
    this.store.$data.isAdmin = undefined;
    this.store.$data.user = undefined;
    this.store.$data.displayName = undefined;
    this.store.$data.icon = undefined;
  }
}

const auth = new Authentication();

export default auth;
